import React, { useCallback } from 'react';
import { SvgIconProps } from '@mui/material';

import { Chip } from '@occc/ui-design-system';

type AcquisitionChannelItemProps = {
  onChange: (value: boolean, name: string) => void;
  value: boolean;
  name: string;
  label: string;
  icon: React.ComponentType<SvgIconProps>;
  disabled?: boolean;
};

export const AcquisitionChannelItem: React.FC<AcquisitionChannelItemProps> = ({
  onChange,
  value,
  name,
  label,
  icon: Icon,
  disabled,
}) => {
  const onItemClick = useCallback(() => {
    onChange(!value, name);
  }, [value, name, onChange]);

  return (
    <Chip
      sx={{ py: 0.5, px: 1 }}
      color={value ? 'primary' : 'default'}
      onClick={onItemClick}
      icon={<Icon fontSize='small' />}
      label={label}
      variant={value ? 'filled' : 'outlined'}
      disabled={disabled}
    />
  );
};
